import { Button, DataGrid } from "devextreme-react";
import { Column, ColumnChooser, FilterPanel, FilterRow, HeaderFilter, Item, Search, SearchPanel, Toolbar, } from "devextreme-react/data-grid";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getPropsDataGrid } from "../../../utils/default-props";
import { useDataSource } from "../../../contexts/dataSource";
import { useNavigate } from "react-router-dom";
import { cellPhotoRender } from "./avatar/avatar";
import { cellNameRender } from "./name-card/name-card";
import { getDataGridCustomToolbar, getDataGridCustomToolbarCaption } from "../../../components/default-components/data-grid-custom-toolbar";
import { usePublicEvents } from "../../../contexts/public-events";



function EmployeList() {

    const navigate = useNavigate();
    const { dataSourceHR } = useDataSource()
    const [id, setId] = useState()
    const { setPublicAddEvent } = usePublicEvents()

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: "/api/Employee/UserMenu"
    }), [])

    const handleFocusedRowChange = (e) => {
        setId(e.component.option('focusedRowKey'));
        //setFocusedRecord(e.row.data)
    }

    const handleRowDblClick = (e) => {
        if (id) navigate(`/employees/employe-card/${id}`)
    }

    const handleAdd = useCallback((e) => {
        navigate('/employees/employe-card')
    }, [])

    useEffect(() => {
        setPublicAddEvent(() => handleAdd)

        return () => {
            setPublicAddEvent(undefined)
        }

    }, [handleAdd])

    return (
        <React.Fragment>

            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    {/* <div className="grid-caption">Employe List</div> */}

                    <DataGrid
                        {...getPropsDataGrid}
                        dataSource={dataSource}
                        focusedRowKey={id}
                        onFocusedRowChanged={handleFocusedRowChange}
                        onRowDblClick={handleRowDblClick}
                        remoteOperations={false}
                        height="70vh"
                    >
                        <Toolbar>

                            {getDataGridCustomToolbarCaption("Personel Listesi")}
                            <Item name="searchPanel" />
                            <Item name="columnChooserButton" />

                        </Toolbar>
                        <HeaderFilter visible />
                        <FilterRow visible />
                        <FilterPanel visible />
                        <SearchPanel visible
                        />
                        <ColumnChooser enabled />

                        {/* 
                        <Column dataField="photo" caption="Foto"
                            width={100}
                            allowFiltering={false}
                            allowSorting={false}
                            cellRender={cellPhotoRender}
                        />
                        <Column dataField="identityNumber" caption="identityNumber" visible={false} />
                        <Column dataField="name" cellRender={cellNameRender} caption="Personel" /> */}
                        {/* // Personel kısmı için name_surname alanı lazım, birleşik */}
                        <Column dataField="name" caption="Adı" visible={true} />
                        <Column dataField="surname" caption="Soyadı" visible={true} />

                        <Column dataField="startDate" dataType="date" caption="İşe Başlama Tarihi" />

                        <Column dataField="officeInfoName" caption="Ofis" />
                        <Column dataField="departmentInfoName" caption="Departman" />
                        <Column dataField="titleInfoName" caption="Ünvanı" />
                        <Column dataField="contractTypeName" caption="Sözleşme Türü" />
                        <Column dataField="workArrangementName" caption="Çalışma Şekli" />
                        <Column dataField="workEnvironmentName" caption="Çalışma Ortamı" />
                        <Column dataField="pciGsm" caption="GSM" />
                        <Column dataField="pciEmail" caption="E-Mail" />
                        <Column dataField="pciPhoneNumber" caption="Telefon" />
                        <Column dataField="companyInfoName" caption="Şirket" />
                        <Column dataField="pciAddress" caption="Adres" />
                        {/* <Column dataField="nationalityName" caption="Uyruğu" /> */}
                        {/* <Column dataField="bloodTypeName" caption="Kan Gurubu" /> */}
                        {/* <Column dataField="maritalStatusName" caption="Medeni Hali" /> */}
                        {/* <Column dataField="genderName" caption="Cinsiyeti" /> */}
                        {/* <Column dataField="motherName" caption="Ana Adı" visible={false}/>
                        <Column dataField="fatherName" caption="Baba Aı" visible={false}/> */}
                        {/* <Column dataField="birthDate" caption="Doğum Tarihi" dataType="date" /> */}

                    </DataGrid>

                    {/* <Button onClick={() => { navigate('/employees/employe-card') }}>Yeni Kayit</Button>
                    <Button onClick={() => { if (id) navigate(`/employees/employe-card/${id}`) }}>Düzenle</Button> */}
                </div>
            </div>
        </React.Fragment>
    )
}


function DataRow(rowInfo) {
    return (
        <React.Fragment>
            <tr className="main-row">
                <td rowSpan="2"><img src={rowInfo.data.photo} style={{ height: "100px" }} /></td>
                <td>{rowInfo.data.name}</td>
                {/* <td>{rowInfo.data.surname}</td>
                <td>{rowInfo.data.motherName}</td>
                <td>{rowInfo.data.fatherName}</td> */}

            </tr>
            <tr className="notes-row">
                <td colSpan="6"><div>{rowInfo.data.companyInfoName}</div></td>
            </tr>
        </React.Fragment>
    );
}
export default EmployeList